import { media,spacing } from '@gyym/ui'
import styled from 'styled-components'

export const SwiperContainer = styled.div`
  margin: 0 auto;
  width: 100%;

  ${media.pc} {
    max-width: 1024px;
  }

  & .swiper-container {
    padding: 0 ${spacing(4)};

    ${media.pc} {
      padding: 0;
    }
  }

  & .swiper-pagination {
    display: none;

    ${media.tablet} {
      display: block;
    }
  }
`
